import Button from "../../../../../components/button/button.jsx";
import ReportUtils from "../../../../../utils/report-utils.js";
import {useEffect} from "react";
import {tableSortHeader} from "../../../../../components/reports/table-sort-header/table-sort-header.jsx";
import {navigateHook} from "../../../../../hooks/use-navigate.js";

export default function ReportContent({ data, filters, tableColumns }) {
    const navigate = navigateHook();

    useEffect(() => {
        if (!data) return;
        ReportUtils.createExportableTable(null, null, "Lista de guarnições", "garrison-list-data");
    }, [data, tableColumns]);

    const { order, handleSort, sortedData, getIcon } = tableSortHeader(data ?? []);

    const intendedFunctionLabels = {
        ADMINISTRATION: "Administração",
        PATROLLING: "Patrulhamento",
        FIXED_LOCATION: "Posto Fixo"
    };

    const columns = [
        {id: "garrison_start", sortField: "garrison_start", className: "w-[12%]", renderCell: (element) => element.garrison_start ?? ""},
        {id: "garrison_end", sortField: "garrison_end", className: "w-[12%]", renderCell: (element) => element.garrison_end ?? ""},
        {id: "garrison_leader", sortField: "garrison_leader", className: "w-[12%]", renderCell: (element) => element.garrison_leader ?? ""},
        {id: "garrison_name", sortField: "garrison_name", className: "w-[22%]", renderCell: (element) => <a onClick={() => navigate(`/despacho/garrison/form/${element.garrison_id}`, true)} className="report-link">{element.garrison_name ?? ""}</a>},
        {id: "garrison_team", sortField: "garrison_team", className: "w-[10%]", renderCell: (element) => element.garrison_team ?? ""},
        {id: "garrison_username", sortField: "garrison_username", className: "w-[10%]", renderCell: (element) => element.garrison_username ?? ""},
        {id: "garrison_intendedfunction", sortField: "garrison_intendedfunction", className: "w-[10%]", renderCell: (element) => intendedFunctionLabels[element.garrison_intendedfunction] ?? element.garrison_intendedfunction},
        {
            id: "garrison_sectors",
            sortField: "garrison_sectors",
            className: "w-[12%]",
            renderCell: (element) => {
                const openGarrisonLocation = () => {
                    const dtStart = filters?.dtStart ? ReportUtils.formatDateTime(filters.dtStart) : "";
                    const dtEnd = filters?.dtEnd ? ReportUtils.formatDateTime(filters.dtEnd) : "";
                    navigate(`/reports/garrison_location_map?garrisonId=${element.garrison_id}&dtStart=${dtStart}&dtEnd=${dtEnd}`, true);
                };

                return (
                    <div className="flex gap-2 justify-between">
                        <span>{element.garrison_sectors ?? ""}</span>
                        <Button
                            disabled={!element.garrison_validate}
                            className="icon-sw-garrison-list print:hidden"
                            title={element.garrison_validate ? "Mapa" : "Indisponível"}
                            onClick={openGarrisonLocation}
                        />
                    </div>
                );
            }
        },
        {id: "initialobservation", className: "w-[15%]", renderCell: (element) => element.initialobservation ?? ""},
        {id: "finalobservation", className: "w-[15%]", renderCell: (element) => element.finalobservation ?? ""}
    ];

    const isExportOnly = (column) => tableColumns?.[column.id]?.exportOnly === true;
    const visibleColumns = columns.filter(column => !isExportOnly(column) && tableColumns?.[column.id]?.visible !== false);
    const exportColumns = columns.filter(column => isExportOnly(column) || tableColumns?.[column.id]?.visible !== false);

    if (!data) return null;

    return (
        <>
            {visibleColumns.length ? null : <div id="noDataMessage" className="alert alert-info p-2 h6 text-center mt-[20px]!">Todas as colunas foram ocultadas.</div>}
            <table id="garrison-list-data" className={`table report-table ${visibleColumns.length ? "" : "hidden"}`}>
                    <thead className="thead-background">
                        <tr className="bg-[#f6f6f6] text-left">
                            {exportColumns.map((column) => (
                                <th key={column.id} onClick={!isExportOnly(column) && column.sortField ? () => handleSort(column.sortField) : undefined} className={`${column.className} ${isExportOnly(column) ? "hidden" : ""} ${!isExportOnly(column) && column.sortField ? "cursor-pointer" : ""}`}>
                                    {tableColumns?.[column.id]?.label ?? column.id} {column.sortField && getIcon(order, column.sortField)}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="bg-white">
                        {sortedData.map((element, index) => (
                            <tr key={element.garrison_id ?? index} className="table-break-word">
                                {exportColumns.map((column) => <td key={column.id} className={`${column.className} ${isExportOnly(column) ? "hidden" : ""}`}>{column.renderCell(element)}</td>)}
                            </tr>
                        ))}
                    </tbody>
                </table>

            <div id="chart-tables"/>
        </>
    );
}